<template>
  <div style="padding-left: 1.75rem">
    <div class="col2_head">
      <router-link :to="'/'" class="breadcrumb_home">Acasă /</router-link>
      {{ $route.name }}
      <div class="subHeadTitle">{{ $route.name }}</div>
      <div
        class="col2_subHead"
        style="margin-top: 1.2rem; display: flex; justify-content: flex-end"
      >
        <div class="Button1 Btn_center" @click="generateExcel">
          <div class="icon">
            <i class="fas fa-download"></i>
          </div>
          <span class="Btn_content"> Descarcă </span>
        </div>
      </div>
    </div>
    <template>
      <template v-if="PERMISIONS.list">
        <table-parent
          :reloadCount="reloadTable"
          :tableHead="tableHead"
          :prepareFn="prepareData"
          :apiModule="tableModule"
          :apiModuleName="'INSTITUTION_PROVIDERS'"
          :tableMinimizeHead="true"
          :tableSpread="true"
          @Btn2="editItem"
          @Btn3="deleteItem"
          @Btn4="openProducts"
          @totalRecords="(x) => (totalRecords = x)"
          @filterQuery="(x) => (currentFilter = x)"
        />
      </template>
      <template v-else>
        <h3 style="display: flex; flex-direction: column; align-items: center">
          <span style="font-size: 4rem">
            <i class="fas fa-exclamation-triangle"></i>
          </span>
          Acces interzis
        </h3>
      </template>
    </template>
  </div>
</template>

<script>
import { saveAs } from "file-saver";
import PermisionsMixin from "@/mixins/institutionProviderPermMixin.js";
import updateRoleStatus from "../mixins/updateUserRoleStatus.js";
import { INSTITUTION_PROVIDERS } from "../api.js";
import DialogModal from "@/components/DialogModal";
import TableParent from "@/components/TableParent";

export default {
  name: "InstitutionProviders",
  $Title() {
    return `ConectX - ${this.$route.name}`;
  },
  mixins: [PermisionsMixin, updateRoleStatus],
  components: {
    TableParent,
  },
  data() {
    return {
      tableHead: [
        {
          title: "CUI",
          queryKey: "cui",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Nume",
          queryKey: "name",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Valoarea totală, fără TVA",
          queryKey: "totalValueWithoutTva",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Valoarea totală, cu TVA",
          queryKey: "totalValueWithTva",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Numărul de comenzi",
          queryKey: "countCmd",
          bottomHead: {
            quikFiltre: true,
          },
        },
      ],
      tableModule: INSTITUTION_PROVIDERS.get,
      totalRecords: 0,
      reloadTable: 0,
      currentFilter: "",
    };
  },
  methods: {
    reload() {
      this.reloadTable++;
    },
    generateExcel() {
      if (!this.totalRecords) {
        this.$toastr.w("Nu există date!");
        return;
      }

      INSTITUTION_PROVIDERS.generate(this.currentFilter)
        .then((res) => {
          saveAs(res, res.filename);
        })
        .catch((err) => {
          console.error(err);
        });
    },

    initHeadTable() {
      const permMap = {
        instName: ["superadmin"],
      };

      const role = this.getUserRole();

      Object.entries(permMap).forEach((e) => {
        const findHead = this.tableHead.find((head) => head.meta == e[0]);
        if (findHead && e[1].includes(role)) {
          findHead.show = true;
        }
      });
    },
    checkTableHeader(meta) {
      const find = this.tableHead.find((e) => e.meta == meta);
      if (find?.show !== false) {
        return true;
      }
      return false;
    },

    openProducts(item) {
      const path = this.$route.path;
      this.$router.push(`${path}/${item.id}`);
    },

    prepareData(row) {
      const preparation = [];
      preparation.push(row.cui || "-");
      preparation.push(row.name || "-");
      preparation.push(this.prepareLocaleNumber(row.totalValueWithoutTva));
      preparation.push(this.prepareLocaleNumber(row.totalValueWithTva));
      preparation.push(row.countCmd);

      const x = this.PERMISIONS;

      const prepareBtn = [];

      if (x.delete === true && !row.countCmd) {
        prepareBtn.push(3);
      }

      if (row.countCmd) {
        prepareBtn.push([
          4,
          "Produse achiziționate",
          ["fas fa-shopping-cart", "font-size:2.2rem;color:#39f;"],
        ]);
      }

      if (prepareBtn.length) {
        preparation.push([prepareBtn]);
      }

      return preparation;
    },
    createItem() {
      const name = {
        label: "Nume",
        id: "name",
        errReason: "Introduceți numele furnizorului.",
      };

      const identifier = {
        label: "Identificator",
        id: "cui",
        errReason: "Introduceți CUI-ul furnizorului.",
      };

      this.$modal.show(
        DialogModal,
        {
          target: "AddInstitutionProvider",
          title: "Adaugă ",
          inputs: [identifier, name],
          closeBtnText: "Anulează",
          button: {
            type: 2,
            value: "Adaugă",
            handler: (sendData) => {
              const error = (msg) => {
                this.$toastr.e(msg || "Adăugarea furnizorului a eșuat.");
                this.reload();
                this.setLoad();
              };

              this.setSafeLoad(12000);
              INSTITUTION_PROVIDERS.add(sendData)
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Furnizorul a fost adăugat.");
                    this.reload();
                    this.setLoad();
                  } else {
                    error();
                  }
                })
                .catch(error);
            },
          },
        },
        {
          name: "AddInstitutionProvider",
          adaptive: true,
          width: "650",
          height: "800",
        },
      );
    },
    editItem(data) {
      if (!Number.isInteger(data.id)) return;
      const name = {
        label: "Nume",
        id: "name",
        errReason: "Introduceți numele furnizorului.",
      };

      const identifier = {
        label: "CUI",
        id: "cui",
        errReason: "Introduceți CUI-ul furnizorului.",
      };

      this.$modal.show(
        DialogModal,
        {
          target: "EditInstitutionProvider",
          title: "Modifică furnizor",
          inputs: [identifier, name],
          initialInputsData: data,
          closeBtnText: "Anulează",
          button: {
            type: 2,
            value: "Modifică",
            handler: (sendData) => {
              sendData = this.getEdited(sendData, data, true);

              const error = (msg) => {
                this.$toastr.e(msg || "Adăugarea furnizorului a eșuat.");
                this.reload();
                this.setLoad();
              };

              this.setSafeLoad(12000);
              INSTITUTION_PROVIDERS.edit(data.id, sendData)
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Datele furnizorului au fost modificate.");
                    this.reload();
                    this.setLoad();
                  } else {
                    error();
                  }
                })
                .catch(error);
            },
          },
        },
        {
          name: "EditInstitutionProvider",
          adaptive: true,
          width: "650",
          height: "800",
        },
      );
    },

    deleteItem(data) {
      if (!Number.isInteger(data?.id)) return;

      this.$modal.show(
        DialogModal,
        {
          target: "DeleteInstitutionProvider",
          title: "Șterge furnizor",
          content:
            '<span style="color:#f44336;display: block;margin-top: 2rem;"><i class="fas fa-exclamation-circle" style="font-size: 6rem;"></i> <p style="font-weight: 500;font-size: 2.2rem;">Ești sigur că vrei să ștergi furnizorul selectat?</p></span>',
          closeBtnText: "Anulează",
          button: {
            type: 3,
            value: "Șterge",
            handler: () => {
              const error = (msg) => {
                this.$toastr.e(msg || "Ștergerea furnizorului a eșuat.");
                this.reload();
                this.setLoad();
              };

              this.setSafeLoad(12000);
              INSTITUTION_PROVIDERS.delete(data.id)
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Funizorul a fost șters.");
                    this.reload();
                    this.setLoad();
                  } else {
                    error();
                  }
                })
                .catch(error);
            },
          },
        },
        {
          name: "DeleteInstitutionProvider",
          adaptive: true,
          width: "650",
          height: "400",
        },
      );
    },
  },
  created() {
    if (!this.PERMISIONS.list) {
      return;
    }

    const canViewButtonsColumn = ["edit", "delete"];
    this.initHeadTable();
    this.updateRoleStatus();
    if (this.checkParamsInObj(this.PERMISIONS, canViewButtonsColumn)) {
      this.tableHead.push({
        spacer: true,
        minimize: 1,
        fixed: {
          right: true,
        },
        bottomHead: {
          quikFiltre: "clear",
        },
      });
    }
  },
};
</script>
